import Vue from 'vue'
import Vuex from 'vuex';
import accountModule from './modules/account.module';
import notificationModule from './modules/notification.module';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        account: accountModule,
        notification: notificationModule
    },
    state: {
        initialized: false,
        appName: "",
        appUrl: "",
        appLocale: "",  /*locale dell'app laravel server per logout*/
        dealer: {},
        user: {},
        language:{},
        menu: {},
        sideMenu: {},
        authUrl: "",
    },
    getters: {
        getInit:        state => { return state.initialized; },
        getAppName:     state => { return state.appName; },
        getAppUrl:      state => { return state.appUrl; },
        getAppLocale:   state => { return state.appLocale; },
        getAppScope:    state => { return state.account.user.group; },
        getDealer:      state => { console.debug('[Deprecated] Use submodule account to access getter'); return state.account.user.dealer; },
        getUser:        state => { console.debug('[Deprecated] Use submodule account to access getter'); return state.account.user; },
        getLanguage:    state => { console.debug('[Deprecated] Use submodule account to access getter'); return state.account.user.language; },
        getTimezone:    state => { return state.account.user.timezone; },
        getAcls: state => { return state.acls; },

        getMenu:            state=> { return state.menu;},
        getSideMenu:        state=> { return state.sideMenu;},
        getNotifications:   state => { return state.notification.notifications; },
        getAuthUrl:         state => state.authUrl,
    },
    mutations: {
        setInit (state, initState){ state.initialized = initState; },
        setAppName (state, name){ state.appName = name; },
        setAppUrl (state, url){ state.appUrl = url; },
        setAppLocale (state, locale){ state.appLocale = locale; },
        setDealer (state, dealer){ state.dealer = dealer; },
        setUser (state, user){ state.user = user; },
        setLanguage (state, language){ state.language = language; },
        setAcls (state, acls){ state.acls = acls; },
        setMenu( state, menu ) { state.menu = menu; },
        setSideMenu( state, sideMenu ) { state.sideMenu = sideMenu; },
        setAuthUrl( state, authUrl ) { state.authUrl = authUrl; },
    },
    actions: {
        init({commit}, laravel) {
            commit('setAppName',   laravel.config.app_name);
            commit('setAppUrl',    laravel.config.app_url);
            commit('setAppLocale', laravel.config.app_locale);
            commit('setAuthUrl', process.env.MIX_AUTH_URL || "")
        }
    }
})
